import { css } from 'aphrodite';
import { CalendarDateIcon } from '../../web/components/svgs/icons/CalendarDateIcon';
import { baseStyleSheet } from '../../web/styles/styles';
import { styleSheet as pageStyles } from '../styles/styles';
import { styleSheet } from './styles';

interface IProps {
	company: string;
	host: string;
	isReschedule: boolean;
	additionalHosts?: string[];
}

export const ScheduleMeetingHeaderHost = ({ company, host, isReschedule, additionalHosts = [] }: IProps) => {
	const meetingType = isReschedule ? 'Reschedule' : 'Schedule';
	const hasAdditionalHosts = additionalHosts && additionalHosts.length > 0;

	return (
		<div>
			<div className={css(styleSheet.calendarIconContainer)}>
				<figure className={css(styleSheet.calendarIconWrapper)}>
					{/* fillColor lands in a `fill` attribute, which can't resolve var(); currentColor defers to the class */}
					<CalendarDateIcon
						className={css(baseStyleSheet.absoluteCenter, styleSheet.calendarIcon)}
						fillColor='currentColor'
					/>
				</figure>
			</div>
			<p className={css(pageStyles.label)}>{meetingType} a Meeting with</p>

			{hasAdditionalHosts ? (
				<div className={css(styleSheet.hostsContainer)}>
					<p className={css(styleSheet.hostWithAdditional)}>{host}</p>
					{additionalHosts.map((additionalHost, index) => (
						<p key={index} className={css(styleSheet.hostWithAdditional)}>
							{additionalHost}
						</p>
					))}
				</div>
			) : (
				<h1 className={css(styleSheet.meetingOwner)}>{host}</h1>
			)}

			<p className={css(pageStyles.text, styleSheet.companyName)}>{company}</p>
		</div>
	);
};
